import React, { forwardRef } from "react";
import { StyledCircularLoader } from "ui-library/Styled";

export interface SimpleLoaderProps {
    loading: boolean;
    size?: number;
}

export const SimpleLoader = forwardRef<HTMLDivElement, SimpleLoaderProps>(({ loading, size = 20 }, ref) => {
    if (!loading) return null;

    return (
        <div ref={ref}>
            <StyledCircularLoader size={size} />
        </div>
    );
});
